// InvoiceHistory.js
import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Alert } from '@mui/material';

// Mock data or fetch logic will go here
const mockInvoices = [
    { id: 'inv_1', date: '2024-08-01T10:00:00Z', description: 'Subscription - Premium Plan', amount: 29.99, currency: 'usd', status: 'paid', pdf_url: '#' },
    { id: 'inv_2', date: '2024-07-01T10:00:00Z', description: 'Subscription - Premium Plan', amount: 29.99, currency: 'usd', status: 'paid', pdf_url: '#' },
    { id: 'inv_3', date: '2024-06-01T09:55:00Z', description: 'Subscription - Basic Plan', amount: 9.99, currency: 'usd', status: 'paid', pdf_url: '#' },
];

const formatCurrency = (amount, currencyCode = 'usd') => {
    if (typeof amount !== 'number') return '';
    try {
         return new Intl.NumberFormat('en-US', {
             style: 'currency',
             currency: currencyCode?.toUpperCase() || 'USD',
         }).format(amount);
    } catch(e) {
         console.warn("Currency formatting failed:", e);
         return `$${amount.toFixed(2)}`; // Fallback with dollar sign
    }
 };

 const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric', month: 'short', day: 'numeric'
        });
    } catch (e) {
        console.warn("Date formatting failed:", e);
        return dateString; // Fallback
    }
 };


const InvoiceHistory = () => {
    // --- STATE ---
    const [invoices, setInvoices] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);

    // --- MOCK FETCH ---
    // Replace with actual API call using useEffect
    React.useEffect(() => {
        const fetchInvoices = async () => {
            setLoading(true);
            setError(null);
            try {
                // TODO: Replace with:
                // 
                // const response = await axiosInstance.get(`/invoices`);
                // setInvoices(response.data); // Assuming response.data is an array of invoices

                // Using mock data for now
                await new Promise(resolve => setTimeout(resolve, 1200)); // Simulate network delay
                setInvoices(mockInvoices);

            } catch (err) {
                console.error("Error fetching invoice history:", err);
                setError(err.response?.data?.message || err.message || "Failed to load invoice history.");
            } finally {
                setLoading(false);
            }
        };

        fetchInvoices();
    }, []);

    // --- RENDER LOGIC ---
     if (loading) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>;
    }

    if (error) {
        return <Alert severity="error">{error}</Alert>;
    }

    return (
        <Box>
            <Typography variant="h5" gutterBottom>
                Billing History
            </Typography>
            {invoices.length === 0 ? (
                <Typography>No invoices found.</Typography>
            ) : (
                <TableContainer component={Paper} variant="outlined">
                    <Table sx={{ minWidth: 650 }} aria-label="invoice history table">
                        <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                            <TableRow>
                                <TableCell>Date</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell align="right">Amount</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Invoice</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {invoices.map((invoice) => (
                                <TableRow
                                    key={invoice.id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        {formatDate(invoice.date)}
                                    </TableCell>
                                    <TableCell>{invoice.description}</TableCell>
                                    <TableCell align="right">{formatCurrency(invoice.amount, invoice.currency)}</TableCell>
                                    <TableCell sx={{ textTransform: 'capitalize' }}>{invoice.status}</TableCell>
                                    <TableCell>
                                        {invoice.pdf_url ? (
                                            <a href={invoice.pdf_url} target="_blank" rel="noopener noreferrer">
                                                View PDF
                                            </a>
                                        ) : (
                                            '-'
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Box>
    );
};

export default InvoiceHistory;